import { render, staticRenderFns } from "./grade.vue?vue&type=template&id=4d260d58&scoped=true&"
import script from "./grade.vue?vue&type=script&lang=js&"
export * from "./grade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d260d58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/NewRabbit/newRabbitAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d260d58')) {
      api.createRecord('4d260d58', component.options)
    } else {
      api.reload('4d260d58', component.options)
    }
    module.hot.accept("./grade.vue?vue&type=template&id=4d260d58&scoped=true&", function () {
      api.rerender('4d260d58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sysconfig/bonusConfig/grade.vue"
export default component.exports